/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { MockInvariantValidator } from "../MockInvariantValidator";

export class MockInvariantValidator__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<MockInvariantValidator> {
    return super.deploy(overrides || {}) as Promise<MockInvariantValidator>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): MockInvariantValidator {
    return super.attach(address) as MockInvariantValidator;
  }
  connect(signer: Signer): MockInvariantValidator__factory {
    return super.connect(signer) as MockInvariantValidator__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MockInvariantValidator {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as MockInvariantValidator;
  }
}

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint128",
            name: "ratio",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "vaultBalance",
            type: "uint128",
          },
        ],
        internalType: "struct BassetData[]",
        name: "_bAssets",
        type: "tuple[]",
      },
      {
        internalType: "uint8",
        name: "_i",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "_rawInput",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "a",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "uint128",
                name: "min",
                type: "uint128",
              },
              {
                internalType: "uint128",
                name: "max",
                type: "uint128",
              },
            ],
            internalType: "struct WeightLimits",
            name: "limits",
            type: "tuple",
          },
        ],
        internalType: "struct InvariantConfig",
        name: "",
        type: "tuple",
      },
    ],
    name: "computeMint",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint128",
            name: "ratio",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "vaultBalance",
            type: "uint128",
          },
        ],
        internalType: "struct BassetData[]",
        name: "_bAssets",
        type: "tuple[]",
      },
      {
        internalType: "uint8[]",
        name: "_indices",
        type: "uint8[]",
      },
      {
        internalType: "uint256[]",
        name: "_rawInputs",
        type: "uint256[]",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "a",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "uint128",
                name: "min",
                type: "uint128",
              },
              {
                internalType: "uint128",
                name: "max",
                type: "uint128",
              },
            ],
            internalType: "struct WeightLimits",
            name: "limits",
            type: "tuple",
          },
        ],
        internalType: "struct InvariantConfig",
        name: "",
        type: "tuple",
      },
    ],
    name: "computeMintMulti",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint128",
            name: "ratio",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "vaultBalance",
            type: "uint128",
          },
        ],
        internalType: "struct BassetData[]",
        name: "_bAssets",
        type: "tuple[]",
      },
      {
        internalType: "uint8",
        name: "_i",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "_mAssetQuantity",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "a",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "uint128",
                name: "min",
                type: "uint128",
              },
              {
                internalType: "uint128",
                name: "max",
                type: "uint128",
              },
            ],
            internalType: "struct WeightLimits",
            name: "limits",
            type: "tuple",
          },
        ],
        internalType: "struct InvariantConfig",
        name: "",
        type: "tuple",
      },
    ],
    name: "computeRedeem",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint128",
            name: "ratio",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "vaultBalance",
            type: "uint128",
          },
        ],
        internalType: "struct BassetData[]",
        name: "_bAssets",
        type: "tuple[]",
      },
      {
        internalType: "uint8[]",
        name: "_indices",
        type: "uint8[]",
      },
      {
        internalType: "uint256[]",
        name: "_rawOutputs",
        type: "uint256[]",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "a",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "uint128",
                name: "min",
                type: "uint128",
              },
              {
                internalType: "uint128",
                name: "max",
                type: "uint128",
              },
            ],
            internalType: "struct WeightLimits",
            name: "limits",
            type: "tuple",
          },
        ],
        internalType: "struct InvariantConfig",
        name: "",
        type: "tuple",
      },
    ],
    name: "computeRedeemExact",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint128",
            name: "ratio",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "vaultBalance",
            type: "uint128",
          },
        ],
        internalType: "struct BassetData[]",
        name: "_bAssets",
        type: "tuple[]",
      },
      {
        internalType: "uint8",
        name: "_i",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "_o",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "_rawInput",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_feeRate",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "a",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "uint128",
                name: "min",
                type: "uint128",
              },
              {
                internalType: "uint128",
                name: "max",
                type: "uint128",
              },
            ],
            internalType: "struct WeightLimits",
            name: "limits",
            type: "tuple",
          },
        ],
        internalType: "struct InvariantConfig",
        name: "",
        type: "tuple",
      },
    ],
    name: "computeSwap",
    outputs: [
      {
        internalType: "uint256",
        name: "bAssetOutputQuantity",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "scaledSwapFee",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "outputMultiplier",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_multiplier",
        type: "uint256",
      },
    ],
    name: "setMultiplier",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
